var proFunction = [
    {
        'url': '/static/image/product/icons/Function@1x.png',
        'url1': '/static/image/product/icons/Function@2x.png',
        'title': 'Function',
        'functionList': [
            {
                'name': 'Apple iBeacon Certified',
                'detail': ['All features of iBeacon ']
            },
            {
                'name': 'Google Eddystone Certified',
                'detail': ['All features of Eddystone supported. ']
            },
            {
                'name': 'Configuable',
                'detail': ['Including UUID, Major, Minor, Tx Power, Interval, etc.']
            },
            {
                'name': 'OTA Upgradable',
                'detail': ['Upgrade Over-The-Air supported.']
            },
            {
                'name': 'Sensor Inside',
                'detail': ['Light, Temperature, Accelerator sensors Integrated (part of models).']
            }
        ]
    },
    {
        'url': '/static/image/product/icons/Cost@1x.png',
        'url1': '/static/image/product/icons/Cost@2x.png',
        'title': 'Cost',
        'functionList': [
            {
                'name': 'Purchase Cost',
                'detail': ['Fine tuned antenna, optimized transmit strength, covering larger area. ']
            },
            {
                'name': 'Maintenance Cost and Maximum battery life',
                'detail': [
                    'Using Nordic nRF 51822 chips, in same Tx power and Advertising interval configuration, double or triple battery lifetime of Ti cc2541 chips.',
                    'Fine tuned antenna, optimized transmit strength, covering same range using lower Tx power.',
                    'Photosynthesis Energy Saving Mode(Patent), extend 1/3 battery lifetime in common scenario(part of models).',
                    'Multiple power supply choices, 4 x AA battery supported with 5~6 times battery life of button cell CR2477 battery, battery changeable(part of models)']
            }
        ]
    },
    {
        'url': '/static/image/product/icons/Security@1x.png',
        'url1': '/static/image/product/icons/Security@2x.png',
        'title': 'Security',
        'functionList': [
            {
                'name': 'Prevent malicious tampering configuration',
                'detail': ['Hardware level password, prevent from malicious configuration modification.']
            },
            {
                'name': 'Prevent Squatters',
                'detail': ['broadcast rotated encrypted major/minor, prevent reading major, minor from squatters.']
            }
        ]
    },
    {
        'url': '/static/image/product/icons/Performance@1x.png',
        'url1': '/static/image/product/icons/Performance@2x.png',
        'title': 'Performance',
        'functionList': [
            {
                'name': 'Extra-Micro Location',
                'detail': ['Dual antenna(Patent), covering radius down to 15cm (part of models).']
            },
            {
                'name': 'Stable Indoor positioning',
                'detail': ['Fine tuned antenna, optimized transmit stability, signal fluctuations was reduced.']
            }
        ]
    },
    {
        'url': '/static/image/product/icons/Deployment@1x.png',
        'url1': '/static/image/product/icons/Deployment@2x.png',
        'title': 'Deployment',
        'functionList': [
            {
                'name': 'Onsite Adaptive Capacity',
                'detail': ['12 degree Tx power, more control on signal covering.']
            },
            {
                'name': 'Mass Deployment Ready',
                'detail': [
                    'Deployment tool provided, batch update configuration on site.',
                    'Pre-Configuration service for batch order, Out of the box.',
                ]
            },
            {
                'name': 'Dense Deployment Ready for extra-precise micro-position',
                'detail': [
                    'Dual antenna(Patent), covering radius down to 15cm, signal interference reduced for extra-precise micro-position (part of models).'
                ]
            }
        ]
    },
    {
        'url': '/static/image/product/icons/Management@1x.png',
        'url1': '/static/image/product/icons/Management@2x.png',
        'title': 'Management',
        'functionList': [
            {
                'name': 'Collect Device Status without Connection',
                'detail': [
                    'Extended iBeacon protocol(Patent), broadcasting device battery level and sensor data .',
                    'Inspection tool provided, collection mass device battery level and sensor data in a dead simple way without connection to each device.'
                ]
            },
            {
                'name': 'Central Monitor Dashboard',
                'detail': [
                    'Central Monitor Dashboard provided, monitor mass device status including battery level, temperature, motion count, light level and other configuration (Tx Power, Adv Interval).'
                ]
            }
        ]
    },
    {
        'url': '/static/image/product/icons/Integratable@1x.png',
        'url1': '/static/image/product/icons/Integratable@2x.png',
        'title': 'Integratable',
        'functionList': [
            {
                'name': 'Integration friendly',
                'detail': [
                    'Collecting device status from your own APP with a few coding lines embedded.',
                    'REST API to access Central Monitor Dashboard data.'
                ]
            }
        ]
    },
    {
        'url': '/static/image/product/icons/Iot@1x.png',
        'url1': '/static/image/product/icons/Iot@2x.png',
        'title': 'Certification',
        'functionList': [
            {
                'name': 'MFi/iBeacon Certified',
                'detail': [
                    'Certify Code: 214945'
                ]
            },
            {
                'name': 'FCC/CE Certified',
                'detail': [
                    'FCC ID: 2ADCH-B0'
                ]
            }
        ]
    },
];
var proList=[
    {
        'url': '/static/image/product/Yunzi@1x.png',
        'url1': '/static/image/product/Yunzi@2x.png',
        'title': 'Yunzi',
        'functionList': [
            {
                'name': 'Energy efficient, including multiple sensors with optimized performance and design',
                'detail': [
                    'Power supply by Panasonic CR2477 Battery >1000 mAh (none-replaceable).',
                    '>1000mAh, battery life is 2 years with common configuration.',
                    'Power saving model based on light sensor.',
                    'Signal range 3m - 80m.',
                    'Water resistance/dust-proof/anti-vibration.',
                    'Polished anodized aluminum alloy ring,White ABS+ transparent PC shell,Matt black ENIG PCB. '
                ]
            }
        ],
        'id':'Yunzi'
    },
    {
        'url': '/static/image/product/SmartBeacon-4AA@1x.png',
        'url1': '/static/image/product/SmartBeacon-4AA@2x.png',
        'title': 'SmartBeacon-4AA',
        'functionList': [
            {
                'name': 'SENSORO is committed to the convergence',
                'detail': [
                    'Power supply by 4 x AA batteries (changeable).',
                    '4000 mAh(Alkaline) ~ 6000 mAh(Lithium), battery life is 5+ years with common configuration.',
                    'Dual-Antenna, signal range 0.15m - 80m.',
                    'Consumer-electronic level designs, white beauty.',
                    'Embedded Temperature sensor.',
                    'Length: 64.0 mm；Width：64.0 mm；Depth：23.5 mm.',
                    'Dust-proof；Anti-vibration.',
                    'Broadcasting interval: 100 ms ~ 1285 ms.'
                ]
            }
        ],
        'id':'SmartBeacon4AA'
    },
    {
        'url': '/static/image/product/4aapro@1x.png',
        'url1': '/static/image/product/4aapro@2x.png',
        'title': 'SmartBeacon-4AA Pro',
        'functionList': [
            {
                'name': 'SENSORO is committed to the convergence',
                'detail': [
                    'Power supply by 4 x AA batteries (changeable).' ,
                    '4000 mAh(Alkaline) ~ 6000 mAh(Lithium), battery life is 5+ years with common configuration.' ,
                    'Dual-Antenna, signal range 0.15m - 80m.' ,
                    'Consumer-electronic level designs, white beauty.' ,
                    'Embedded Temperature sensor.' ,
                    'Length: 72.69 mm；Width：70.00 mm；Depth：29.76 mm.' ,
                    'Water-proof; Dust-proof; Anti-vibration.' ,
                    'Broadcasting interval: 100 ms ~ 1285 ms.'
                ]
            }
        ],
        'id':'SmartBeacon4AAPro'
    },
    {
        'url': '/static/image/product/SmartBeacon-USB@1x.png',
        'url1': '/static/image/product/SmartBeacon-USB@1x.png',
        'title': 'SmartBeacon-USB',
        'functionList': [
            {
                'name': 'SENSORO is committed to the convergence',
                'detail': [
                    'Power supply by USB, unlimited battery life.' ,
                    'Dual-Antenna, signal range 0.15m - 80m.' ,
                    'Consumer-electronic level designs, white beauty.' ,
                    'Length: 43.0 mm；Width：17.4 mm；Depth：7.4 mm.' ,
                    'Dust-proof；Anti-vibration.' ,
                    'Broadcasting interval: 100 ms ~ 1285 ms.'
                ]
            }
        ],
        'id':'SmartBeaconUSB'
    }
]
var proStation=[
    {
        'url': '/static/image/product/Alpha_Base Station@1x.png',
        'url1': '/static/image/product/Alpha_Base Station@2x.png',
        'title': 'Alpha Base Station',
        'functionList': [
            {
                'name': 'The Alpha Base Station features strong signal coverage with a centrally managed platform. Designed for outdoor installations, it\'s built to withstand harsh environments and industrial settings. As the core infrastructure of the SENSORO IoT-WAN, its powerful data processing capability is designed to support and connect thousands of nodes and provide a data path from the sensor endpoints all the way to the cloud.',
                'detail': [
                    'Easy to configure with the centralized management platform' ,
                    'Local configuration possible using BLE,' ,
                    'Supports IoT-WAN, Ethernet, and 3G' ,
                    'Ruggedized for outdoor installations with IP67 certification'
                ]
            }
        ],
        'id':'AlphaBaseStation',
        'docs':'/static/docs/α_Base_Station.pdf'
    },
    {
        'url': '/static/image/product/Alpha_Gateway@1x.png',
        'url1': '/static/image/product/Alpha_Gateway@2x.png',
        'title': 'Alpha Gateway',
        'functionList': [
            {
               'name': 'The Alpha Gateway features excellent indoor signal coverage and strong hardware protection, is designed and built for indoor IoT scenarios that require low power-consumption, long range and low throughput, hence capable of handling the data communication of a large-scale sensor network. It support and connect thousands of nodes into the network and provide a data path from the nodes all the way to the cloud. ',
                'detail': [
                    'High grade full metal material, overall thermal design' ,
                    'Tri-layer encryption to ensure data security' ,
                    'multiple communication modes to servers (4G, Ethernet, Wi-Fi)' ,
                    'Multi network backup options to ensure stability in data communication'
                ]
            }
        ],
        'id':'AlphaGateway',
        'docs':'/static/docs/α_Space_Gateway.pdf'
    },
    {
        'url': '/static/image/product/AlphaNode-4AA@1x.png',
        'url1': '/static/image/product/AlphaNode-4AA@2x.png',
        'title': 'Alpha Node-4AA',
        'functionList': [
            {
                'name': 'The Alpha Node-4AA is an IoT low-power sensor developed by SENSORO with excellent signal coverage, supporting both proximity and long-range communication. The Alpha Node-4AA operates as an end device in the IoT-WAN low-power network for long-range sensing, monitoring, and remote device management, with built-in sensors for temperature, humidity, and ambient light. It can also function as a BLE-based low-power beacon, supporting multiple near-field transmission protocols such as Apple iBeacon and Google Eddystone.',
                'detail': [
                    'Easily configured and managed from the centralized management platform' ,
                    'Temperature, humidity, and ambient light IoT sensors' ,
                    'Traditional beacon functionality built-in' ,
                    'Powered by standard AA batteries for long-life and easy maintenance' ,
                    'Drop-in installation, easily deployed and repositioned'
                ]
            }
        ],
        'id':'AlphaNode4AA',
        'docs':'/static/docs/α_Node-4AA.pdf'
    },
    {
        'url': '/static/image/product/Alpha_Commander@1x.png',
        'url1': '/static/image/product/Alpha_Commander@2x.png',
        'title': 'Alpha Commander',
        'functionList': [
            {
                'name': 'The SENSORO Alpha Commander is a highly scalable centralized management engine that monitors, configures, and manages the entire IoT sensor network through a simple console interface. The Alpha Commander provides management of the end-devices as well as the base stations, and the intuitive interface provides the ability to quickly check device status, configure sensor operating parameters, and monitor sensor information. Data can be easily redirected from the Alpha Commander to other applications for data storage and analysis.',
                'detail': [
                    'Powerful centralized management of the entire IoT network' ,
                    'Configure, manage, and monitor your devices from the console' ,
                    'Quickly assess the health of all devices on the IoT network' ,
                    'Access your sensor data using standard options including MQTT, HTTP, and API'
                ]
            }
        ]
    },
    {
        'url': '/static/image/product/Alpha_Chip@1x.png',
        'url1': '/static/image/product/Alpha_Chip@2x.png',
        'title': 'Alpha Chipset',
        'functionList': [
            {
                'name': 'The Alpha Chipset enables sensor manufacturers to integrate their devices into an IoT sensor network quickly and easily. Sensor OEMs can simply include the Alpha Chipset in their design and immediately empower IoT network functionality. Data from a customized sensor is sent to the Alpha Chipset through the UART interface, and effortlessly the Alpha platform takes care of the rest.',
                'detail': [
                    'Small footprint, only 11x11mm' ,
                    'UART interface supports up to 115,200 baud' ,
                    'Sleep/wake GPIO for lowered power consumption'
                ]
            }
        ],
        'id':'AlphaModule',
        'linkTo':'http://docs.sensoro.com/en/'
    }
]
module.exports={
    proFunction:proFunction,
    proList:proList,
    proStation:proStation
}



// WEBPACK FOOTER //
// ./src/assets/js/productList.js